module.exports = __webpack_public_path__ + "img/spa-sauna.bf16626c.svg";